import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    // hasIncompatibleSources is set to true if we try to load json sources in
    // CDO Blockly, which only supports xml.
    hasIncompatibleSources: false,
};
var blocklySlice = createSlice({
    name: 'blockly',
    initialState: initialState,
    reducers: {
        setHasIncompatibleSources: function (state, action) {
            state.hasIncompatibleSources = action.payload;
        },
    },
});
export var setHasIncompatibleSources = blocklySlice.actions.setHasIncompatibleSources;
export default blocklySlice.reducer;
